<div fxLayout="row" fxLayoutAlign="space-between center" class="p-2" class="search">
    <div fxLayout="row">
        <button  mat-icon-button  color="primary" matTooltip="Affichage en Grille" (click)="changeViewType('grid')">
            <span><mat-icon>grid_view</mat-icon></span>
        </button>
        <button  mat-icon-button  color="primary" matTooltip="Affichage en Liste" (click)="changeViewType('list')">
            <span><mat-icon>format_list_bulleted</mat-icon></span>
        </button>
        <mat-button-toggle-group #controls="matButtonToggleGroup" appearance="legacy">            
            <mat-button-toggle value="search">
                <mat-icon>search</mat-icon>
            </mat-button-toggle>           
        </mat-button-toggle-group>            
    </div>
    <form class="user-search" [class.show]="controls.value == 'search'">
        <mat-form-field class="user-search-input">
            <input matInput placeholder="Recherche d'un état de lieu..." (keyup)="applyFilter($event)" name="search">
        </mat-form-field>
    </form>
</div>

<mat-card class="m-2 p-0">
    <div class="table-wrapper" *ngIf="viewType==='list'">

        <table mat-table [dataSource]="dataSource" matSort class="w-100">

            <!-- FullName Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> N° </th>
                <td mat-cell *matCellDef="let constat">{{constat.id}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date d'enregistrement </th>
                <td mat-cell *matCellDef="let constat">{{constat.created_at}} </td>
            </ng-container>
            <ng-container matColumnDef="declarant">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Propriétaire </th>
                <td mat-cell *matCellDef="let constat">          {{constat.declarant_name}} </td>
            </ng-container>
            <ng-container matColumnDef="locataire">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Locataire </th>
                <td mat-cell *matCellDef="let constat">{{constat.locataire_name}} </td>
            </ng-container>
            <ng-container matColumnDef="vehicule">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Véhicule</th>
                <td mat-cell *matCellDef="let constat">{{constat.vehicle_value+","+constat.vehicle_model}}</td>
            </ng-container>
            <ng-container matColumnDef="statut">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Statut</th>
                <td mat-cell *matCellDef="let car">
                    <button mat-button [matMenuTriggerFor]="menu">{{car.statut_constat}} <mat-icon>expand_more</mat-icon> </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item  disabled>en attente</button>
                        <button mat-menu-item disabled>Validé</button>
                        <button mat-menu-item disabled>Refusé</button>
                        <button mat-menu-item (click)="changeStatus(car.id,'annulé')" [disabled]="car.statut_constat=='annulé' || car.statut_constat=='refusé'">Annulé</button>
                    </mat-menu>
                </td>
            </ng-container>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef  > Actions </th>

                <td mat-cell *matCellDef="let constat">
                    <button mat-icon-button color="warn" (click)="deleteConstat(constat.id)" matTooltip="clear"  *ngIf="constat.statut_constat=='en_attente' && constat.declarant_id ==this.userIn.id ">
                        <mat-icon>clear</mat-icon>
                    </button>
                    <button mat-icon-button color="primary" (click)="visibility(constat.id)" matTooltip="visibility">
                        <mat-icon>visibility</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" (click)="downloadPdf(constat.contrat)" matTooltip="Contrat" *ngIf="constat.signature_declarant !=null && constat.signature_locataire !=null">
                        <mat-icon>receipt_long</mat-icon>
                    </button>
                    
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let user; columns: displayedColumns;"></tr>
        </table>
        <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">Aucune données enregistrées</p>
    </div>
    
    <div fxLayout="row wrap" fxLayoutAlign="center" class="w-100 p-2" *ngIf="viewType==='grid'">
        <mat-card class="menu-item" [fxLayout]="(viewType == 'grid') ? 'column' : 'row'"
            [ngClass]="[viewType + '-item', 'column-'+column]" fxFlex.gt-sm="30" fxFlex.sm="30"  *ngFor="let item of resultcat | paginate: { itemsPerPage: 10, currentPage: p }">
           
            <div fxFlex="100" class="p-3">
                <div fxLayout="column" fxLayoutAlign="start stretch" class="h-100">
                    <mat-card-content class="mb-0">
                        <mat-icon class="icon-title">assignment</mat-icon>
                        <h1 class="title">
                            {{item.vehicle_value+" "+item.mod_lib}}
                        </h1>
                        <div> 
                            <div class="features">
                                <p>
                                    propriétaire: {{item.declarant_name}} <br>
                                    locataire: {{item.locataire_name}} <br>
                                </p>
                                <span *ngIf="item.statut_constat == 'en_attente'" style="color: blue; font-size:24px; line-height: 1px;"><mat-icon class="">clock_arrow_up</mat-icon> En attente de validation</span>
                                <span *ngIf="item.statut_constat == 'validé'" style="color: rgb(3, 154, 3); font-size:24px; line-height: 1px;" ><mat-icon class="">task_alt</mat-icon> validé</span>
                                <span *ngIf="item.statut_constat == 'refusé'" style="color:red; font-size:24px; line-height: 1px;"><mat-icon class="">unpublished</mat-icon> Refusé</span>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions class="m-0 p-0">
                        <div class="divider mt-1">
                            <span class="text-muted text-center">
                                {{item.created_at| date:"dd MMMM, yyyy 'a' HH:mm" }}
                            </span>
                        </div>
                        <div xLayout="row wrap" fxLayoutAlign="center">
                            <button mat-icon-button color="warn" (click)="deleteConstat(item.id)" matTooltip="clear"  *ngIf="item.statut_constat=='en_attente' && item.declarant_id ==this.userIn.id ">
                                <mat-icon>clear</mat-icon>
                            </button>
                            <button mat-icon-button color="primary" (click)="visibility(item.id)" matTooltip="visibility">
                                <mat-icon>visibility</mat-icon>
                            </button>
                            <button mat-icon-button color="warn" (click)="downloadPdf(item.contrat)" matTooltip="Contrat" *ngIf="item.signature_declarant !=null && item.signature_locataire !=null">
                                <mat-icon>receipt_long</mat-icon>
                            </button>
                        </div>
                    </mat-card-actions>
                </div>
            </div>
        </mat-card>
        <p *ngIf="resultcat && resultcat.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p> 

    </div>
    <div fxLayout="row wrap" fxLayoutAlign="space-between" class="w-100 p-2">
        <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20">
            <button  mat-icon-button  color="primary" matTooltip="Rafraichir" (click)="refresh()">
                <span><mat-icon>refresh</mat-icon> Mise à jour</span>
            </button>
        </div>
        
        <div fxFlex="100" fxFlex.gt-sm="80" fxFlex.sm="80" *ngIf="viewType==='grid'">
            <pagination-controls (pageChange)="p = $event" style="text-align: end;"></pagination-controls>
        </div>
        <mat-paginator class="{{viewType==='list' ? 'block' : 'hidden'}}" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
    </div>
</mat-card>